import GatsbyImage, { GatsbyImageProps } from 'gatsby-image';
import styled from 'styled-components';
import { lightGray } from '../utils/styles';

export const Image = styled(GatsbyImage).attrs({
  loading: 'lazy',
})<GatsbyImageProps>`
  border-radius: 5px;
  box-shadow: 0 2px 2px -1px ${lightGray};
  transition: box-shadow 0.3s, transform 0.3s;
`;
